function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-unused-vars */
import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { FONT_MODES, pxToRem } from "../common";
import attunedDarkTheme from "./dark-theme";
import attunedLightTheme from "./light-theme";
import '@fontsource/open-sans';
export { attunedDarkTheme, attunedLightTheme };
var defaultFontFamily = 'Open Sans, Roboto, Helvetica, Arial, sans-serif';
var intermediaryTheme = createTheme();
export var generateTheme = function generateTheme(theme, fontSize, overrides) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    textSize: []
  };
  return createTheme(adaptV4Theme({
    palette: theme,
    typography: {
      fontSize: FONT_MODES[fontSize],
      fontFamily: defaultFontFamily,
      h6: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        fontSize: pxToRem(16)
      }, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: pxToRem(15)
      }), intermediaryTheme.breakpoints.down('md'), {
        fontSize: pxToRem(14)
      }), intermediaryTheme.breakpoints.down('sm'), {
        fontSize: pxToRem(14)
      }), intermediaryTheme.breakpoints.down('xs'), {
        fontSize: pxToRem(13)
      }),
      pageHeader: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        fontFamily: defaultFontFamily,
        fontWeight: 300,
        fontSize: pxToRem(30)
      }, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: pxToRem(26)
      }), intermediaryTheme.breakpoints.down('md'), {
        fontSize: pxToRem(24)
      }), intermediaryTheme.breakpoints.down('sm'), {
        fontSize: pxToRem(20)
      }), intermediaryTheme.breakpoints.down('xs'), {
        fontSize: pxToRem(16)
      }),
      sectionHeader: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        fontSize: pxToRem(18),
        fontFamily: defaultFontFamily
      }, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: pxToRem(16)
      }), intermediaryTheme.breakpoints.down('md'), {
        fontSize: pxToRem(16)
      }), intermediaryTheme.breakpoints.down('sm'), {
        fontSize: pxToRem(14)
      }), intermediaryTheme.breakpoints.down('xs'), {
        fontSize: pxToRem(13)
      }),
      body1: _defineProperty(_defineProperty({
        fontSize: pxToRem(16)
      }, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: pxToRem(16)
      }), intermediaryTheme.breakpoints.down('md'), {
        fontSize: pxToRem(12)
      }),
      body2: _defineProperty(_defineProperty({
        fontSize: pxToRem(12)
      }, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: pxToRem(12)
      }), intermediaryTheme.breakpoints.down('md'), {
        fontSize: pxToRem(12)
      }),
      loginTitle: {
        fontSize: pxToRem(24),
        fontWeight: 300,
        lineHeight: '24px',
        fontFamily: defaultFontFamily,
        fontStyle: 'normal'
      },
      loginDescription: {
        fontSize: pxToRem(16),
        lineHeight: '24px',
        fontFamily: defaultFontFamily,
        fontStyle: 'normal',
        fontWeight: 300
      },
      legacyTextSize: opts.textSize
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 1024,
        lg: 1240,
        xl: 1680,
        xxl: 1920
      },
      keys: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']
    },
    overrides: _objectSpread({
      MuiOutlinedInput: {
        root: {
          color: theme.font.primary
        }
      },
      MuiDrawer: {
        root: {
          '& .MuiDrawer-paper': {
            background: theme.content.secondary
          }
        }
      },
      MuiTableCell: {
        root: {
          borderBottom: theme.table.row.border,
          padding: '5px'
        },
        body: {
          color: theme.font.primary
        },
        stickyHeader: {
          backgroundColor: theme.title.primary,
          color: theme.font.primary
        }
      },
      MuiTableRow: {
        hover: {
          '&:hover': {
            background: "".concat(theme.table.row.hover.primary, " !important")
          }
        }
      },
      MuiToolbar: {
        root: {
          background: theme.content.primary,
          color: theme.font.primary
        }
      },
      MuiAutocomplete: {
        listbox: {
          backgroundColor: theme.table.filter.secondary,
          color: theme.font.primary
        },
        option: {
          '&[data-focus="true"]': {
            backgroundColor: theme.table.row.hover.primary
          }
        }
      },
      MuiFormControlLabel: {
        root: {
          '& .Mui-checked > .MuiIconButton-label > svg': {
            color: '#f50057 !important'
          },
          '& span': {
            color: theme.font.primary
          }
        }
      },
      MuiTableSortLabel: {
        icon: {
          color: "".concat(theme.font.secondary, " !important")
        }
      },
      MuiSkeletonRoot: {
        backgroundColor: 'rgba(248, 248, 248, 0.8)'
      }
    }, overrides)
  }));
};